<script setup>
import { toLocaleDateStringIgnoringTimezone } from '~/common/DateUtils';
import { numberFormatter } from '~/common/FieldFormats';

defineProps({
  totals: {
    type: Object,
    required: true,
  },
  contributors: {
    type: Array,
    required: true,
  },
  mergeDate: {
    type: Date,
    required: true,
  },
});
</script>

<template>
  <div class="p-3">
    <p>
      {{ contributors.length }} contributors submitted
      {{ numberFormatter(totals.opened_merge_requests) }} merge requests.
      <br>
      {{ numberFormatter(totals.merged_merge_requests) }} merge requests (worth {{ numberFormatter(totals.score) }} points)
      were merged before {{ toLocaleDateStringIgnoringTimezone(mergeDate) }}.
    </p>
  </div>
</template>
